import { AutoComplete } from "primereact/autocomplete";
import { Calendar } from "primereact/calendar";
import { Checkbox } from "primereact/checkbox";
import { InputNumber } from "primereact/inputnumber";
import { InputSwitch } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Password } from "primereact/password";
import { PickList } from "primereact/picklist";
import { RadioButton } from "primereact/radiobutton";
import { Button } from 'primereact/button';
import { useEffect } from "react";
import { MultiSelect } from 'primereact/multiselect';
import { MdOutlineFilePresent, MdOutlineGTranslate } from "react-icons/md";
import { toast } from "react-toastify";
import './inputField.module.css'

export const InputField = ({
    id,
    type,
    name,
    label,
    labelFor,
    required,
    errors,
    messagePosition='bottom',
    defaultValue,
    disabled = false,
    register,
    width,
    rows=1,
    value,
    optionLabel,
    autoFilteredValue,
    autoCompleteMethod,
    selectedAutoValue,
    setSelectedAutoValue,
    className,
    checked,
    onChange,
    translateHandler,
    setSwitchChecked,
    switchChecked,
    onBlur,
    imagePreview,
    setImagePreview,
    onSelect,
    onClick,
    inputGroup,
    inputGroupIcon,
    switchClassName,
    picklistSourceValue,
    picklistTargetValue,
    setPicklistSourceValue,
    setPicklistTargetValue,
    sourceHeader,
    targetHeader,
    fileUploadPadding,
    autoCompleteFieldName,
    maxFractionDigits,
    minFractionDigits,
    prefix,
    suffix,
    mode,
    min,
    filePreview,
    radioBtnmap,
    selectionMode,
    minDate,
    maxDate,
    maxlength,
    onClose,
    accept,
    loading,
    btnColor,
    autoFocus,
    placeholder,
    options,
    ...rest
}) => {
    useEffect(() => {
        if (errors && messagePosition === 'toast') {
            toast.error(errors, {
                onClose,
            });
        }
    }, [errors]);

    return (
        <>
            {type !== "image" && (
                <span className="p-float-label">
                    {!inputGroup && type === "text" && (
                        <>
                            <InputText id={id} name={name} style={{'borderColor': `${required && !value?.length ? '#f97316' : ''}`}} className={`rounded-md w-${width}`} disabled={disabled} value={value == null ? "" : value} onChange={onChange} required={required} onBlur={onBlur} onClick={onClick} />
                            <label className="text-[#A2B3C4]" htmlFor={labelFor}>
                                {label}
                            </label>
                            {errors && messagePosition === 'bottom' && (
                                <p style={{"color": 'red'}}>{errors}</p>
                            )}
                        </>
                    )}
                    {!inputGroup && type === "button" && (
                        <>
                            <Button 
                                label={label} 
                                className={`p-button-${btnColor} mr-2 mb-2`} 
                                disabled={disabled}
                                type={type} 
                                onClick={onClick}
                                loading={loading}
                                />
                        </>
                    )}
                    {!inputGroup && type === "number" && (
                        <>
                            <InputText id={id} name={name} className={`rounded-md ${required && !value?.length && "border-red-500"} w-${width}`} disabled={disabled} value={value == null ? "" : value} onChange={onChange} required={required} onBlur={onBlur} onClick={onClick} />
                            <label className="text-[#A2B3C4]" htmlFor={labelFor}>
                                {label}
                            </label>
                        </>
                    )}
                    {!inputGroup && type === "numbers" && (
                        <>
                            <InputNumber
                                id={id}
                                name={name}
                                className={`rounded-md ${required && !value && "inputNumber"} w-${width}`}
                                disabled={disabled}
                                value={value == null ? "" : value}
                                onChange={onChange}
                                required={required}
                                onBlur={onBlur}
                                onClick={onClick}
                                mode={mode || "decimal"}
                                locale="en-US"
                                minFractionDigits={minFractionDigits || 0}
                                maxFractionDigits={maxFractionDigits || 3}
                                min={min || 0}
                                prefix={prefix}
                                suffix={suffix}
                                maxLength={maxlength}
                                {...rest}
                            />
                            <label className="text-[#A2B3C4]" htmlFor={labelFor}>
                                {label}
                            </label>
                            {errors && messagePosition === 'bottom' && (
                                <p style={{"color": 'red'}}>{errors}</p>
                            )}
                        </>
                    )}
                    {!inputGroup && type === "autoFocus" && (
                        <>
                            <InputText
                                id={id}
                                name={name}
                                className={`rounded-md ${required && !value && "inputNumber"} w-${width}`}
                                disabled={disabled}
                                value={value == null ? "" : value}
                                onChange={onChange}
                                required={required}
                                onBlur={onBlur}
                                onClick={onClick}
                                mode={mode}
                                autoFocus={autoFocus}
                                maxLength={maxlength}
                                {...rest}
                            />
                            <label className="text-[#A2B3C4]" htmlFor={labelFor}>
                                {label}
                            </label>
                        </>
                    )}
                    {!inputGroup && type === "password" && (
                        <>
                            <Password
                                id={id}
                                name={name}
                                className={`rounded-md ${required && !value?.length && "border-red-500"} w-${width}`}
                                disabled={disabled}
                                value={value == null ? "" : value}
                                onChange={onChange}
                                required={required}
                                onBlur={onBlur}
                                onClick={onClick}
                                feedback={false}
                                inputClassName={`rounded-md ${required && !value?.length && "border-red-500"} w-${width}`}
                            />
                            <label className="text-[#A2B3C4]" htmlFor={labelFor}>
                                {label}
                            </label>
                        </>
                    )}
                    {type === "textarea" && (
                        <>
                            {/* <InputTextarea autoResize rows={rows} cols="30" id={id} name={name} className={`rounded-md ${required && !value && "border-red-500"} w-${width}`} disabled={disabled} value={value == null ? "" : value} onChange={onChange} required={required} onBlur={onBlur} /> */}
                            <InputTextarea 
                                autoResize 
                                id={id} 
                                name={name} 
                                disabled={disabled}
                                value={value == null ? "" : value} 
                                onChange={onChange} 
                                required={required} 
                                onBlur={onBlur}
                                style={{borderColor: required && !value ? 'rgb(249, 115, 22)' : '1px solid #ced4da'}}
                            />
                            <label htmlFor={labelFor}>{label}</label>
                        </>
                    )}
                    {type === "select" && (
                        <>
                            <AutoComplete
                                dropdown
                                suggestions={autoFilteredValue}
                                completeMethod={autoCompleteMethod}
                                field={autoCompleteFieldName || "label"}
                                id={id}
                                name={name}
                                className={`rounded-md w-${width} ${required && !value?.length && !value?.label?.length && "autoComplete-red"}`}
                                disabled={disabled}
                                value={value == null ? "" : value}
                                onChange={onChange}
                                onBlur={onBlur}
                                autoHighlight
                                onSelect={onSelect}
                                onClick={onClick}
                                defaultValue={defaultValue}
                                dropdownAutoFocus
                                required={required} // not working
                                style={{ width: width }}
                                size={10}
                                forceSelection
                            />
                            <label htmlFor={labelFor}>{label}</label>

                            {errors && required && (
                                <p style={{"color": 'red'}}>{errors}</p>
                            )}
                        </>
                    )}
                    {type === "date" && (
                        <>
                            <Calendar
                                showIcon
                                showButtonBar
                                className={`rounded-md ${required && !value && "border-red-500"} w-${width}`}
                                required={required}
                                value={value}
                                onChange={onChange}
                                id={id}
                                name={name}
                                disabled={disabled}
                                onClick={onClick}
                                onBlur={onBlur}
                                onSelect={onSelect}
                                yearRange="1900:2050"
                                dateFormat="yy/mm/dd"
                                maxDate={maxDate}
                                minDate={minDate}
                                style={{ width: width }}
                                showOnFocus
                            />
                            <label className="text-[#A2B3C4]" htmlFor={labelFor}>
                                {label}
                            </label>
                            {errors && messagePosition === 'bottom' && (
                                <p style={{"color": 'red'}}>{errors}</p>
                            )}
                        </>
                    )}
                    {type === "translate" && (
                        <>
                            <div className="p-inputgroup ">
                                <div className="p-float-label">
                                    <InputText className={`rounded-md ${required && !value?.length && "border-red-500"} w-${width}`} />
                                    <label className="text-[#A2B3C4]" htmlFor={labelFor}>
                                        {label}
                                    </label>
                                    <button type="" icon={<MdOutlineGTranslate />} className="bg-gray-500 text-2xl" onClick={translateHandler} />
                                </div>
                            </div>
                        </>
                    )}

                    {type === "switch" && (
                        <div className={!switchClassName ? "border border-gray-400 grid grid-cols-2 p-3 rounded-md bg-white" : switchClassName}>
                            <p className="text-gray-600  ">{label}</p>
                            <div className="justify-self-end">
                                <InputSwitch checked={switchChecked || false} onChange={setSwitchChecked} id={id} name={name} value={value} />
                            </div>
                        </div>
                    )}

                    {type === "checkbox" && (
                        <>
                            <Checkbox inputId={id} name={name} value={value} checked={checked} onChange={onChange} />
                            <label htmlFor={labelFor} className={className}>
                                {label}
                            </label>
                        </>
                    )}
                    {type === "multipleselect" && (
                        <>
                            <MultiSelect 
                                name={name} 
                                value={value} 
                                onChange={onChange} 
                                options={options} 
                                optionLabel="name" 
                                filter 
                                placeholder={placeholder} 
                                maxSelectedLabels={6} 
                                className="w-full" />
                            <label htmlFor={labelFor} className={className}>
                                {label}
                            </label>
                        </>
                    )}
                    {inputGroup && type === "text" && (
                        <div className="col-12 md:col-4 rounded-md">
                            <div className="p-inputgroup">
                                <span className="p-inputgroup-addon">
                                    <i className={inputGroupIcon}></i>
                                </span>
                                <span className="p-float-label">
                                    <InputText id={id} name={name} className={`rounded-md ${required && !value?.length && "border-red-500"} w-${width}`} disabled={disabled} value={value == null ? "" : value} onChange={onChange} required={required} onBlur={onBlur} onClick={onClick} />
                                    <label className="text-[#A2B3C4]" htmlFor={labelFor}>
                                        {label}
                                    </label>
                                </span>
                            </div>
                        </div>
                    )}
                    {inputGroup && type === "password" && (
                        <div className="col-12 md:col-4">
                            <div className="p-inputgroup">
                                <span className="p-inputgroup-addon">
                                    <i className={inputGroupIcon}></i>
                                </span>
                                <span className="p-float-label">
                                    <Password
                                        id={id}
                                        name={name}
                                        className={`${required && !value?.length && "border-red-500"} w-${width}`}
                                        disabled={disabled}
                                        value={value == null ? "" : value}
                                        onChange={onChange}
                                        required={required}
                                        onBlur={onBlur}
                                        onClick={onClick}
                                        feedback={false}
                                        inputClassName={` ${required && !value?.length && "border-red-500"} w-${width}`}
                                    />
                                    <label className="text-[#A2B3C4]" htmlFor={labelFor}>
                                        {label}
                                    </label>
                                </span>
                            </div>
                        </div>
                    )}
                </span>
            )}
            {type === "image" && (
                <>
                    <div className={`flex flex-col w-full  border-2 border-dashed ${required && !imagePreview ? "border-red-500 hover:bg-gray-100 hover:border-gray-300" : "border-gray-400"} rounded`}>
                        {imagePreview ? (
                            <div className="imageBox flex flex-col items-center justify-center" style={{paddingLeft: "70px"}}>
                                <img className="object-cover  w-32 h-32" src={imagePreview} alt="" height='300px' width='400px'/>
                                <button type="button" onClick={setImagePreview} className="text-red-600 text-center text-sm deleteButton px-2 py-2">
                                    <i className="pi pi-trash" style={{ color: 'red' }}></i>
                                </button>
                            </div>
                        ) : (
                            <label className="imageBox p-1">
                                <div className="flex flex-col items-center justify-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-gray-400 group-hover:text-gray-600" viewBox="1 2 35 15" fill="currentColor">
                                        <path fillRule="evenodd" d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z" clipRule="evenodd" />
                                    </svg>
                                    <p className="pt-1 text-sm tracking-wider text-gray-400 group-hover:text-gray-600">{label}</p>
                                </div>
                                <input accept="image/*" pattern="([^\\s]+(\\.(?i)(jpe?g|png|gif|bmp))$)" name={name} id={id} type="file" className="opacity-0" onChange={onChange} onBlur={onBlur} required={required} />
                            </label>
                        )}
                    </div>
                </>
            )}

            {type === "file" && (
                <>
                    <div className={`flex flex-col w-full  border border-solid ${required && !filePreview ? "border-red-400 hover:bg-red-100 hover:border-red-300 " : "border-gray-400 hover:bg-gray-100 hover:border-gray-300"} rounded-lg `}>
                        <label className={`imageBox p-${fileUploadPadding || "2"} `}>
                            <div className="flex items-center justify-center pt-7 gap-2">
                                <MdOutlineFilePresent className="text-3xl  font-light " />
                                <p className="p-1 text-md tracking-wider text-gray-600 group-hover:text-gray-600 bg-cyan-400 rounded-md">Attach File</p>
                            </div>
                            <input name={name} id={id} type="file" className="opacity-0" onChange={onChange} onBlur={onBlur} multiple required={required} accept={accept} />
                        </label>
                    </div>
                </>
            )}
            {type === "file2" && (
                <>
                    <div className={`flex flex-col w-full  border border-solid ${required && !filePreview ? "border-red-400 hover:bg-red-100 hover:border-red-300 " : "border-gray-400 hover:bg-gray-100 hover:border-gray-300"} rounded-lg `}>
                        <label className={`imageBox h-12 p-${fileUploadPadding || "2"} `}>
                            <div className="flex items-center justify-center pt-1 gap-2">
                                <MdOutlineFilePresent className="text-3xl  font-light " />
                                <p className="p-1 text-md tracking-wider text-gray-600 group-hover:text-gray-600 bg-cyan-400 rounded-md">Attach File</p>
                            </div>
                            <input name={name} id={id} type="file" className="opacity-0" onChange={onChange} onBlur={onBlur} multiple required={required} accept={accept} />
                        </label>
                    </div>
                </>
            )}
            {type === "pickList" && (
                <>
                    <PickList
                        source={picklistSourceValue}
                        target={picklistTargetValue}
                        sourceHeader={sourceHeader}
                        targetHeader={targetHeader}
                        itemTemplate={(item) => <div>{item.name}</div>}
                        onChange={(e) => {
                            !onChange ? setPicklistSourceValue(e.source) : onChange(e);
                            !onChange ? setPicklistTargetValue(e.target) : onChange(e);
                        }}
                        sourceStyle={{ height: "200px" }}
                        targetStyle={{ height: "200px" }}
                        showTargetControls={false}
                        showSourceControls={false}
                        {...rest}
                    ></PickList>
                </>
            )}
            {type === "radio" && (
                <>
                    <div className="p-radiobutton">
                        {radioBtnmap.map(({ label, value, checked, onChange }) => (
                            <div className="flex items-center gap-2">
                                <RadioButton inputId={id} name={name} value={value} checked={checked} onChange={onChange} className="ml-2" />
                                <label htmlFor={labelFor} className={`p-radiobutton-label`}>
                                    {label}
                                </label>
                            </div>
                        ))}
                    </div>
                </>
            )}
            {!inputGroup && type === "website" && (
                <div className="p-inputgroup">
                    <span className="p-inputgroup-addon">www</span>
                    <InputText id={id} name={name} placeholder={'dekkoisho.com'} className={`rounded-md w-${width}`} disabled={disabled} value={value == null ? "" : value} onChange={onChange} required={required} onBlur={onBlur} onClick={onClick} />

                </div>
            )}
        </>
    );
};
